<template>
  <div class="row content-box full-height">
    <woot-button
      v-if="showAddButton && !isCatalog"
      color-scheme="success"
      class-names="button--fixed-top mt-50 bg-primary"
      icon="add-circle"
      @click="openAddHookModal"
    >
      {{ $t('INTEGRATION_APPS.ADD_BUTTON') }}
    </woot-button>
    <woot-button
      v-if="showAddButton && isCatalog"
      class-names="button--fixed-top mt-50 bg-primary"
      icon="add-circle"
      size="medium"
      @click="openAddCatalog"
    >
      {{ $t('INTEGRATION_APPS.ADD_BUTTON_CATALOG') }}
    </woot-button>
    <div v-if="showIntegrationHooks" class="integration-hooks">
      <div v-if="isIntegrationMultiple && !isCatalog">
        <multiple-integration-hooks
          :integration="integration"
          @delete="openDeletePopup"
        />
      </div>

      <div v-if="isIntegrationMultiple && isCatalog">
        <catalog-integration
          :integration="integration"
          @delete="openDeletePopup"
        />
      </div>

      <div v-if="isIntegrationSingle">
        <single-integration-hooks
          :integration="integration"
          @add="openAddHookModal"
          @delete="openDeletePopup"
        />
      </div>
    </div>

    <woot-modal :show.sync="showAddHookModal" :on-close="hideAddHookModal">
      <new-hook :integration="integration" @close="hideAddHookModal" />
    </woot-modal>

    <modal-catalog-product
      :integration="integration"
      :show-catalog-modal="showAddNewCatalog"
      @on-close="hideAddCatalog"
    />
    <woot-delete-modal
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :is-loading="loadingDelete"
      :title="deleteTitle"
      :message="deleteMessage"
      :confirm-text="confirmText"
      :reject-text="cancelText"
    />

    <hire-plan-modal
      :show-modal="showPlanHireModal"
      :integration="integration"
      @hide-modal-hire-plan="closeModalHirePlan"
    />
  </div>
</template>
<script>
import { isEmptyObject } from '../../../../helper/commons';
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import hookMixin from './hookMixin';
import NewHook from './NewHook';
import SingleIntegrationHooks from './SingleIntegrationHooks';
import MultipleIntegrationHooks from './MultipleIntegrationHooks';
import ModalCatalogProduct from './catalog/ModalCatalogProduct.vue';
import CatalogIntegration from './catalog/CatalogIntegration.vue';
import HirePlanModal from './HirePlanModal.vue';

export default {
  components: {
    NewHook,
    SingleIntegrationHooks,
    MultipleIntegrationHooks,
    ModalCatalogProduct,
    CatalogIntegration,
    HirePlanModal,
  },
  mixins: [alertMixin, hookMixin],
  props: {
    integrationId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: {},
      showAddHookModal: false,
      showDeleteConfirmationPopup: false,
      showAddNewCatalog: false,
      selectedHook: {},
      alertMessage: '',
      loadingDelete: false,
      showPlanHireModal: false
    };
  },
  watch: {
    account: {
      handler() {
        this.guardUpdateAvatar();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'integrations/getUIFlags',
      getAccount: 'accounts/getAccount',
      currentAccountId: 'getCurrentAccountId',
    }),
    account() {
      return this.getAccount(this.currentAccountId);
    },
    integration() {
      return this.$store.getters['integrations/getIntegration'](
        this.integrationId
      );
    },
    isCatalog() {
      return this.integrationId === 'catalog';
    },
    showIntegrationHooks() {
      return (
        (!this.uiFlags.isFetching && !isEmptyObject(this.integration)) ||
        this.isCatalog
      );
    },
    integrationType() {
      return this.integration.allow_multiple_hooks ? 'multiple' : 'single';
    },
    isIntegrationMultiple() {
      return this.integrationType === 'multiple';
    },
    isIntegrationSingle() {
      return this.integrationType === 'single';
    },
    showAddButton() {
      return this.showIntegrationHooks && this.isIntegrationMultiple;
    },
    deleteTitle() {
      return this.isHookTypeInbox
        ? this.$t('INTEGRATION_APPS.DELETE.TITLE.INBOX')
        : this.$t('INTEGRATION_APPS.DELETE.TITLE.ACCOUNT');
    },
    deleteMessage() {
      return this.isHookTypeInbox
        ? this.$t('INTEGRATION_APPS.DELETE.MESSAGE.INBOX')
        : this.$t('INTEGRATION_APPS.DELETE.MESSAGE.ACCOUNT');
    },
    confirmText() {
      return this.isHookTypeInbox
        ? this.$t('INTEGRATION_APPS.DELETE.CONFIRM_BUTTON_TEXT.INBOX')
        : this.$t('INTEGRATION_APPS.DELETE.CONFIRM_BUTTON_TEXT.ACCOUNT');
    },
    cancelText() {
      return this.$t('INTEGRATION_APPS.DELETE.CANCEL_BUTTON_TEXT');
    },
  },
  mounted() {
    if (this.integrationId === 'wise') {
      this.$router.replace({ name: 'settings_applications' });
      return;
    }
    this.$store.dispatch('integrations/get');
    this.guardUpdateAvatar();
  },
  methods: {
    guardUpdateAvatar() {
      if (this.integrationId !== 'update_avatar') return;
      if (!this.account?.id) return;
      if (!this.account.enable_update_avatar) {
        this.$router.replace({ name: 'settings_applications' });
      }
    },
    closeModalHirePlan() {
      this.showPlanHireModal = false;
    },

    openAddHookModal() {
      if (this.integrationId === 'quotation' && !this.account.enable_quote) {
        this.showPlanHireModal = true;
        return;
      }
      if (this.integrationId === 'update_avatar' && !this.account?.enable_update_avatar) {
        this.$router.replace({ name: 'settings_applications' });
        return;
      }
      this.showAddHookModal = true;
    },
    hideAddHookModal() {
      this.showAddHookModal = false;
    },
    openAddCatalog() {
      this.showAddNewCatalog = true;
    },
    hideAddCatalog() {
      this.showAddNewCatalog = false;
    },
    openDeletePopup(response) {
      this.showDeleteConfirmationPopup = true;
      this.selectedHook = response;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },
    cleanQuotation() {
      this.$store.dispatch('cleanDataQuotation');
    },
    async confirmDeletion() {
      try {
        this.loadingDelete = true;
        await this.$store.dispatch('integrations/deleteHook', {
          hookId: this.selectedHook.id,
          appId: this.selectedHook.app_id,
        });
        this.alertMessage = this.isCatalog
          ? this.$t('INTEGRATION_APPS.DELETE_CATALOG')
          : this.$t('INTEGRATION_APPS.DELETE.API.SUCCESS_MESSAGE');

        if (this.selectedHook.app_id == 'quotation') {
          this.cleanQuotation();
        }
      } catch (error) {
        const errorMessage = error?.response?.data?.message;
        this.loadingDelete = false;
        this.closeDeletePopup();
        this.alertMessage =
          errorMessage || this.$t('INTEGRATION_APPS.DELETE.API.ERROR_MESSAGE');
      } finally {
        this.loadingDelete = false;
        this.closeDeletePopup();
        this.showAlert(this.alertMessage);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.integration-hooks {
  width: 100%;
}
</style>
